export const ATTRIBUTE_QUALIFIER_EQUAL = "ATTRIBUTE_QUALIFIER_EQUAL";
export const ATTRIBUTE_QUALIFIER_IS_NOT_EQUAL = "ATTRIBUTE_QUALIFIER_IS_NOT_EQUAL";
export const ATTRIBUTE_QUALIFIER_IS_EMPTY = "ATTRIBUTE_QUALIFIER_IS_EMPTY";
export const ATTRIBUTE_QUALIFIER_IS_NOT_EMPTY = "ATTRIBUTE_QUALIFIER_IS_NOT_EMPTY";
export const ATTRIBUTE_QUALIFIER_CONTAINS = "ATTRIBUTE_QUALIFIER_CONTAINS";
export const ATTRIBUTE_QUALIFIER_DOES_NOT_CONTAINS = "ATTRIBUTE_QUALIFIER_DOES_NOT_CONTAINS";
export const ATTRIBUTE_QUALIFIER_IS_TRUE = "ATTRIBUTE_QUALIFIER_IS_TRUE";
export const ATTRIBUTE_QUALIFIER_IS_FALSE = "ATTRIBUTE_QUALIFIER_IS_FALSE";
export const ATTRIBUTE_QUALIFIER_VARIANT_INVENTORY_POLICE_CONTINUE = "ATTRIBUTE_QUALIFIER_VARIANT_INVENTORY_POLICE_CONTINUE";
export const ATTRIBUTE_QUALIFIER_VARIANT_INVENTORY_POLICE_DENY = "ATTRIBUTE_QUALIFIER_VARIANT_INVENTORY_POLICE_DENY";
export const ATTRIBUTE_QUALIFIER_HAS_TAGS = "ATTRIBUTE_QUALIFIER_HAS_TAGS";
export const ATTRIBUTE_QUALIFIER_HAS_NOT_TAGS = "ATTRIBUTE_QUALIFIER_HAS_NOT_TAGS";
export const ATTRIBUTE_QUALIFIER_CONTAINS_TAGS = "ATTRIBUTE_QUALIFIER_CONTAINS_TAGS";
export const ATTRIBUTE_QUALIFIER_DOES_NOT_CONTAINS_TAGS = "ATTRIBUTE_QUALIFIER_DOES_NOT_CONTAINS_TAGS";
export const ATTRIBUTE_QUALIFIER_LARGER = "ATTRIBUTE_QUALIFIER_LARGER";
export const ATTRIBUTE_QUALIFIER_LESS = "ATTRIBUTE_QUALIFIER_LESS";
export const ATTRIBUTE_QUALIFIER_SELECT_VALUE = "ATTRIBUTE_QUALIFIER_SELECT_VALUE";
export const ATTRIBUTE_QUALIFIER_MULTIPLE_LOCATIONS = "ATTRIBUTE_QUALIFIER_MULTIPLE_LOCATIONS";
export const ATTRIBUTE_QUALIFIER_PRODUCT_IS_NOT_ACTIVE = "ATTRIBUTE_QUALIFIER_PRODUCT_IS_NOT_ACTIVE";
export const ATTRIBUTE_QUALIFIER_HAS_LOCATIONS = "ATTRIBUTE_QUALIFIER_HAS_LOCATIONS";
export const ATTRIBUTE_QUALIFIER_HAS_NOT_LOCATIONS = "ATTRIBUTE_QUALIFIER_HAS_NOT_LOCATIONS";
